import type { enStokTransfers } from '../en/stok-transfers';

export const idStokTransfers: Record<keyof typeof enStokTransfers, string> = {
  // ---- Transfer: daftar -------------------------------------------------------------------
  'stok.transfers.title': 'Transfer',
  'stok.transfers.subtitle':
    'Pindahkan stok antarlokasi di {branch} atau ke cabang lain. Nilainya ikut berpindah dengan biaya rata-rata.',
  'stok.transfers.new': 'Buat transfer',
  'stok.transfers.noRead': 'Melihat transfer memerlukan izin baca inventaris atau izin transfer.',
  'stok.transfers.readOnly':
    'Anda dapat melihat transfer. Membuat, mengirim, dan membatalkannya memerlukan izin transfer.',
  'stok.transfers.directionLabel': 'Arah',
  'stok.transfers.outgoing': 'Keluar',
  'stok.transfers.incoming': 'Masuk',
  'stok.transfers.outgoingDesc':
    'Dibuat di cabang ini: perpindahan antarlokasi sendiri dan kiriman ke cabang lain.',
  'stok.transfers.incomingDesc': 'Dikirim ke sini oleh cabang lain — terima setelah barang tiba.',
  'stok.transfers.listLabel': 'Transfer',
  'stok.transfers.emptyOutgoing':
    'Belum ada transfer. Buat transfer untuk memindahkan stok ke lokasi atau cabang lain.',
  'stok.transfers.emptyReadOnly': 'Belum ada transfer. Transfer muncul di sini setelah dibuat.',
  'stok.transfers.emptyIncoming':
    'Tidak ada kiriman masuk. Transfer yang dikirim cabang lain ke cabang ini muncul di sini.',
  'stok.transfers.search': 'Nomor, lokasi, atau cabang',
  'stok.transfers.colNumber': 'Nomor',
  'stok.transfers.colRoute': 'Dari → ke',
  'stok.transfers.colLines': 'Baris',
  'stok.transfers.colDates': 'Tanggal',
  'stok.transfers.fromBranch': 'Dari cabang',
  'stok.transfers.allBranches': 'Semua cabang',
  'stok.transfers.interBranch': 'Ke cabang lain',
  'stok.transfers.intraBranch': 'Dalam cabang',
  'stok.transfers.to': 'ke',
  'stok.transfers.valueAtDispatch': 'Dinilai saat dikirim',
  'stok.transfers.createdAt': 'Dibuat {time}',
  'stok.transfers.dispatchedAt': 'Dikirim {time}',
  'stok.transfers.receivedAt': 'Diterima {time}',
  'stok.transfers.dispatched': 'Dikirim',
  'stok.transfers.received': 'Diterima',
  'stok.transfers.status.draft': 'Draf',
  'stok.transfers.status.in_transit': 'Dalam perjalanan',
  'stok.transfers.status.received': 'Diterima',
  'stok.transfers.status.cancelled': 'Dibatalkan',

  // ---- Transfer: baru ---------------------------------------------------------------------
  'stok.transfers.back': 'Kembali ke transfer',
  'stok.transfers.newTitle': 'Transfer baru',
  'stok.transfers.newSubtitle': 'Disimpan sebagai draf. Stok baru berpindah saat transfer dikirim.',
  'stok.transfers.noPermission': 'Membuat transfer memerlukan izin transfer.',
  'stok.transfers.noItems':
    'Belum ada barang aktif. Tambahkan barang di data master terlebih dahulu.',
  'stok.transfers.noLocations': 'Cabang ini belum memiliki lokasi stok aktif.',
  'stok.transfers.routeTitle': 'Rute',
  'stok.transfers.routeDesc': 'Dari mana stok keluar dan ke mana tujuannya.',
  'stok.transfers.from': 'Dari',
  'stok.transfers.fromHint': 'Lokasi di {branch}.',
  'stok.transfers.toBranch': 'Cabang tujuan',
  'stok.transfers.toBranchHint':
    'Cabang ini, atau cabang lain tempat Anda bekerja (mata uang sama).',
  'stok.transfers.toBranchOnly': 'Anda hanya bekerja di cabang ini.',
  'stok.transfers.thisBranch': '{name} (cabang ini)',
  'stok.transfers.toLocation': 'Ke',
  'stok.transfers.pickLocation': 'Pilih lokasi',
  'stok.transfers.toHintSame': 'Lokasi lain di cabang ini.',
  'stok.transfers.toHintOther': 'Lokasi di {branch}.',
  'stok.transfers.destLoading': 'Memuat lokasi…',
  'stok.transfers.destFailed': 'Lokasi cabang ini tidak dapat dimuat. Coba lagi.',
  'stok.transfers.destForbidden':
    'Anda tidak dapat melihat lokasi cabang ini (perlu izin baca inventaris di sana).',
  'stok.transfers.destNone': 'Tidak ada lokasi aktif lain untuk dipilih.',
  'stok.transfers.interNote':
    'Stok keluar dari cabang ini saat dikirim dan berstatus dalam perjalanan sampai {branch} menerimanya.',
  'stok.transfers.linesTitle': 'Baris',
  'stok.transfers.linesDesc':
    'Maksimal {max} baris. Untuk barang ber-lot, kosongkan lot agar yang kedaluwarsa paling awal diambil lebih dulu (FEFO).',
  'stok.transfers.lineLabel': 'Baris {n}',
  'stok.transfers.removeLine': 'Hapus baris {n}',
  'stok.transfers.addLine': 'Tambah baris',
  'stok.transfers.pickItem': 'Pilih barang',
  'stok.transfers.inBase': 'Dalam satuan dasar:',
  'stok.transfers.fefo': 'Otomatis (FEFO)',
  'stok.transfers.lotHint': 'Lot di lokasi asal beserta kedaluwarsa dan jumlahnya.',
  'stok.transfers.lotsNone':
    'Tidak ada stok lot di lokasi ini — FEFO tidak akan menemukan apa pun.',
  'stok.transfers.lotsFailed': 'Lot tidak dapat dimuat; FEFO tetap berfungsi.',
  'stok.transfers.blockExpired': 'Kedaluwarsa',
  'stok.transfers.fefoTakes': 'FEFO saat ini akan mengambil: {lots}.',
  'stok.transfers.fefoShort': 'Stok lot yang dapat dipakai kurang {qty} — pengiriman akan ditolak.',
  'stok.transfers.fefoBlocked': '{count} lot yang diblokir tidak pernah dipakai otomatis.',
  'stok.transfers.overrideReason': 'Alasan pengecualian',
  'stok.transfers.overrideHintExpired':
    'Lot ini sudah kedaluwarsa. Jelaskan mengapa tetap boleh dipindah, misalnya “Ke area karantina”. Dicatat di log audit.',
  'stok.transfers.overrideHintHeld':
    'Lot ini sedang ditahan. Jelaskan mengapa tetap boleh dipindah, misalnya “Ke area karantina”. Dicatat di log audit.',
  'stok.transfers.blockedNoRightExpired':
    'Lot ini sudah kedaluwarsa. Memindahkannya memerlukan izin persetujuan inventaris dan alasan — pilih lot lain, gunakan FEFO, atau minta bantuan manajer.',
  'stok.transfers.blockedNoRightHeld':
    'Lot ini sedang ditahan. Memindahkannya memerlukan izin persetujuan inventaris dan alasan — pilih lot lain, gunakan FEFO, atau minta bantuan manajer.',
  'stok.transfers.notes': 'Catatan',
  'stok.transfers.notesHint': 'Untuk pengirim dan penerima, maksimal 300 karakter.',
  'stok.transfers.draftNote': 'Draf belum memindahkan stok.',
  'stok.transfers.saveDraft': 'Simpan draf',
  'stok.transfers.created': 'Transfer {number} disimpan sebagai draf.',
  'stok.transfers.err.from': 'Pilih dari mana stok keluar.',
  'stok.transfers.err.toBranch': 'Pilih cabang tujuan.',
  'stok.transfers.err.to': 'Pilih lokasi tujuan.',
  'stok.transfers.err.sameLocation': 'Pilih lokasi selain lokasi asal.',
  'stok.transfers.err.notes': 'Gunakan maksimal 300 karakter.',
  'stok.transfers.err.noLines': 'Tambahkan minimal satu baris.',
  'stok.transfers.err.tooManyLines': 'Gunakan maksimal 100 baris.',
  'stok.transfers.err.item': 'Pilih barang.',
  'stok.transfers.err.qty': 'Masukkan jumlah lebih dari 0.',
  'stok.transfers.err.unit': 'Pilih satuan.',
  'stok.transfers.err.precision':
    'Jumlah ini tidak dapat dikonversi tepat ke satuan dasar. Gunakan lebih sedikit desimal.',
  'stok.transfers.err.override': 'Tulis alasan pengecualian minimal 3 karakter.',
  'stok.transfers.err.overrideLong': 'Gunakan maksimal 300 karakter.',
  'stok.transfers.err.blockedNoRight':
    'Lot ini diblokir. Hanya pemegang izin persetujuan inventaris yang dapat memindahkannya.',
  'stok.transfers.err.blockedForbidden':
    'Memindahkan lot yang ditahan atau kedaluwarsa memerlukan izin persetujuan inventaris.',
  'stok.transfers.err.lotExpired':
    'Lot yang dipilih sudah kedaluwarsa. Berikan alasan pengecualian atau pilih lot lain.',
  'stok.transfers.err.lotOnHold':
    'Lot yang dipilih sedang ditahan. Berikan alasan pengecualian atau pilih lot lain.',
  'stok.transfers.err.insufficient': 'Stok di lokasi asal tidak cukup.',
  'stok.transfers.err.insufficientQty':
    'Stok {item} di lokasi asal tidak cukup: tersedia {available}, dibutuhkan {requested}.',
  'stok.transfers.err.insufficientLotQty':
    'Stok lot {item} yang dapat dipakai tidak cukup (lot kedaluwarsa dan ditahan tidak dihitung): tersedia {available}, dibutuhkan {requested}.',
  'stok.transfers.err.state': 'Transfer ini sudah berubah. Status terbaru ditampilkan.',

  // ---- Transfer: detail -------------------------------------------------------------------
  'stok.transfers.detailTitle': 'Transfer',
  'stok.transfers.factsTitle': 'Rincian',
  'stok.transfers.kind': 'Jenis',
  'stok.transfers.createdBy': 'Dibuat oleh',
  'stok.transfers.dispatchedBy': 'Dikirim oleh',
  'stok.transfers.receivedBy': 'Diterima oleh',
  'stok.transfers.linesCount': '{count} baris',
  'stok.transfers.fefoShortLabel': 'FEFO',
  'stok.transfers.override': 'Pengecualian',
  'stok.transfers.total': 'Total',
  'stok.transfers.valueNote':
    'Nilai ditetapkan saat dikirim dari biaya rata-rata; pihak penerima mendapat nilai yang sama persis.',
  'stok.transfers.actionsTitle': 'Langkah berikutnya',
  'stok.transfers.stepDraft': 'Mengirim langsung memindahkan stok ke lokasi tujuan.',
  'stok.transfers.stepDraftInter':
    'Mengirim mengeluarkan stok dari cabang ini; cabang tujuan yang menerimanya.',
  'stok.transfers.stepInTransit': 'Dalam perjalanan — menunggu {branch} menerimanya.',
  'stok.transfers.stepReceived': 'Selesai: stok sudah berada di tujuan.',
  'stok.transfers.stepCancelled': 'Dibatalkan sebelum dikirim; tidak ada stok yang berpindah.',
  'stok.transfers.dispatch': 'Kirim',
  'stok.transfers.dispatching': 'Mengirim…',
  'stok.transfers.dispatchTitle': 'Kirim {number}?',
  'stok.transfers.dispatchBody': '{count} baris: {route}.',
  'stok.transfers.dispatchIntraWarning':
    'Stok berpindah sekarang dan buku besar mencatat kedua sisinya. Tindakan ini tidak dapat dibatalkan.',
  'stok.transfers.dispatchInterWarning':
    'Stok keluar dari cabang ini sekarang dan berstatus dalam perjalanan sampai {branch} menerimanya. Tindakan ini tidak dapat dibatalkan.',
  'stok.transfers.dispatchedDone': 'Transfer {number} dikirim dan diterima.',
  'stok.transfers.dispatchedInTransit': 'Transfer {number} dikirim — kini dalam perjalanan.',
  'stok.transfers.receive': 'Terima',
  'stok.transfers.receiving': 'Menerima…',
  'stok.transfers.receiveTitle': 'Terima {number}?',
  'stok.transfers.receiveBody': 'Stok dari {from} dicatat masuk ke {location}.',
  'stok.transfers.receiveWarning':
    'Terima setelah barang tiba. Lot tetap memakai kode dan tanggal kedaluwarsa yang sama.',
  'stok.transfers.receiveReadOnly':
    'Menerima memerlukan izin transfer atau izin penerimaan di cabang ini.',
  'stok.transfers.receivedDone': 'Transfer {number} diterima.',
  'stok.transfers.awaitingReceipt':
    'Penerimaan dilakukan di {branch}: orang yang bekerja di sana yang mengonfirmasinya.',
  'stok.transfers.openAtDestination': 'Pindah ke {branch}',
  'stok.transfers.draftElsewhere': 'Draf milik {branch}; pengirimannya dilakukan di sana.',
  'stok.transfers.cancelDraft': 'Batalkan draf',
  'stok.transfers.cancelling': 'Membatalkan…',
  'stok.transfers.cancelTitle': 'Batalkan {number}?',
  'stok.transfers.cancelBody': 'Draf ditutup dan tidak ada stok yang berpindah.',
  'stok.transfers.cancelWarning': 'Transfer yang dibatalkan tidak dapat dikirim lagi.',
  'stok.transfers.cancelledDone': 'Transfer {number} dibatalkan.',
  'stok.transfers.viewLedger': 'Lihat di buku besar stok',
  'stok.transfers.resultTitle': 'Mutasi yang dicatat',
  'stok.transfers.resultDesc': 'Yang dicatat langkah ini di buku besar stok.',
  'stok.transfers.resultEmpty': 'Tidak ada mutasi yang dicatat.',

  // ---- Opname: tambah barang/lot ditemukan -------------------------------------------------
  'stok.countAdd.open': 'Tambah barang/lot ditemukan',
  'stok.countAdd.title': 'Tambah barang atau lot yang ditemukan',
  'stok.countAdd.desc':
    'Stok yang ditemukan di {location} tetapi tidak ada di lembar hitung. Ditambahkan dengan jumlah seharusnya 0 — hitung seperti baris lainnya.',
  'stok.countAdd.rowLabel': 'Temuan {n}',
  'stok.countAdd.removeRow': 'Hapus temuan {n}',
  'stok.countAdd.addRow': 'Tambah temuan lain',
  'stok.countAdd.pickItem': 'Pilih barang',
  'stok.countAdd.noLot': 'Tanpa lot: dihitung sebagai satu baris.',
  'stok.countAdd.pickLot': 'Pilih lot',
  'stok.countAdd.lotLoading': 'Memuat lot…',
  'stok.countAdd.lotHint':
    'Lot yang sudah ada di cabang ini, termasuk yang kosong. Lot baru dicatat lewat penerimaan, bukan lewat opname.',
  'stok.countAdd.lotNone':
    'Semua lot barang ini sudah ada di lembar hitung, atau barang ini belum punya lot.',
  'stok.countAdd.lotExpiry': 'kedaluwarsa {date}',
  'stok.countAdd.lotHere': '{qty} di sini',
  'stok.countAdd.noItems': 'Semua barang aktif sudah ada di lembar hitung.',
  'stok.countAdd.note': 'Hanya selama opname berlangsung (tidak saat hitung ulang).',
  'stok.countAdd.submit': 'Tambahkan ke lembar hitung',
  'stok.countAdd.added': '{count} baris ditambahkan ke lembar hitung.',
  'stok.countAdd.err.item': 'Pilih barang.',
  'stok.countAdd.err.lot': 'Pilih lot yang ditemukan.',
  'stok.countAdd.err.onSheet': 'Sudah ada di lembar hitung.',
  'stok.countAdd.err.duplicate': 'Tercantum dua kali.',
  'stok.countAdd.err.none': 'Tambahkan minimal satu barang.',

  // ---- Laporan akurasi opname -------------------------------------------------------------
  'stok.countAccuracy.title': 'Akurasi stok',
  'stok.countAccuracy.subtitle':
    'Seberapa dekat hasil stok opname yang diposting di {branch} dengan catatan pembukuan.',
  'stok.countAccuracy.rangeTitle': 'Periode',
  'stok.countAccuracy.rangeDesc':
    'Opname yang penyesuaiannya diposting pada tanggal bisnis ini ({timeZone}).',
  'stok.countAccuracy.period': '{from} – {to}',
  'stok.countAccuracy.accuracy': 'Akurasi',
  'stok.countAccuracy.accuracyDesc': 'Baris dalam toleransi ÷ baris yang dievaluasi.',
  'stok.countAccuracy.ofLines': '{within} dari {evaluated} baris',
  'stok.countAccuracy.noneEvaluated': 'Tidak ada baris yang dievaluasi pada periode ini.',
  'stok.countAccuracy.counts': 'Opname diposting',
  'stok.countAccuracy.countsDesc': 'Stok opname yang diposting pada periode ini.',
  'stok.countAccuracy.variance': 'Nilai selisih',
  'stok.countAccuracy.varianceDesc':
    'Hasil hitung dikurangi seharusnya, dengan biaya rata-rata ({currency}).',
  'stok.countAccuracy.varianceHint': 'Negatif = stok hilang.',
  'stok.countAccuracy.excluded': 'Baris dikecualikan',
  'stok.countAccuracy.excludedDesc': 'Tidak termasuk dalam pembagi.',
  'stok.countAccuracy.excludedHint':
    'Baris yang tidak pernah dibandingkan dengan pembukuan (misalnya tidak dihitung sebelum diposting) tidak menaikkan maupun menurunkan akurasi.',
  'stok.countAccuracy.excludedNone': 'Semua baris opname ini sudah dievaluasi.',
  'stok.countAccuracy.byLocation': 'Per lokasi',
  'stok.countAccuracy.byLocationDesc': 'Akurasi per lokasi yang dihitung.',
  'stok.countAccuracy.colCounts': 'Opname',
  'stok.countAccuracy.colEvaluated': 'Baris dievaluasi',
  'stok.countAccuracy.empty':
    'Belum ada opname yang diposting pada periode ini. Akurasi muncul setelah stok opname disetujui dan diposting.',
  'stok.countAccuracy.def.scope': 'Cakupan',
  'stok.countAccuracy.def.accuracy': 'Akurasi',
  'stok.countAccuracy.def.excluded': 'Baris dikecualikan',
  'stok.countAccuracy.def.varianceValue': 'Nilai selisih',
};
